import { render, staticRenderFns } from "./finishRegistrationPage.vue?vue&type=template&id=ab1c4c82&scoped=true&"
import script from "./finishRegistrationPage.vue?vue&type=script&lang=js&"
export * from "./finishRegistrationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab1c4c82",
  null
  
)

export default component.exports